import { render } from "./VisitSyncToMssql.vue?vue&type=template&id=8c319350&scoped=true"
import script from "./VisitSyncToMssql.vue?vue&type=script&lang=js"
export * from "./VisitSyncToMssql.vue?vue&type=script&lang=js"

import "./VisitSyncToMssql.vue?vue&type=style&index=0&id=8c319350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c319350"]])

export default __exports__